import { render } from "./UserEdit.html?vue&type=template&id=34e125d8&ts=true"
import script from "./UserEdit.ts?vue&type=script&lang=ts"
export * from "./UserEdit.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__